import axios from "axios";
import { v4 as uuidv4 } from "uuid";

const { VITE_API_URL, DEV, VITE_WHAT_ID } = import.meta.env;
const uuid = uuidv4();

let headers = {
    "Content-Type": "application/json",
    "req-xid-token": uuid,
    "Authorization": uuid,
};

const instance = axios.create({
    baseURL: VITE_API_URL,
    headers: headers,
    withCredentials: true,
    responseType: "json",
});

const _postByUrlData = async (url, data) => {
    try {
        let req = await instance.post(url, data);
        if (req.data) {
            return req.data;
        }
    } catch (e) {
        console.log(e);
        return { success: false, msg: e.message, dataError: e };
    }
};

export { _postByUrlData };
